(function () {
  document.querySelectorAll('[data-starter-showcase]').forEach(function (gallery) {
    var tabs = Array.prototype.slice.call(gallery.querySelectorAll('[data-showcase-target]'));
    var panels = Array.prototype.slice.call(gallery.querySelectorAll('[data-showcase-panel]'));
    var tourVideo = gallery.querySelector('[data-tour-video]');
    if (!tabs.length || !panels.length || gallery.dataset.ready === 'true') return;
    gallery.dataset.ready = 'true';

    function setTour(active) {
      if (!tourVideo) return;
      if (active) {
        var playPromise = tourVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
      } else {
        tourVideo.pause();
        tourVideo.currentTime = 0;
      }
    }

    function activate(id, focus) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.showcaseTarget === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach(function (panel) {
        var active = panel.dataset.showcasePanel === id;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      setTour(id === 'tour');
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab.dataset.showcaseTarget, false); });
      tab.addEventListener('keydown', function (event) {
        if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'].indexOf(event.key) === -1) return;
        event.preventDefault();
        var next = index;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        activate(tabs[next].dataset.showcaseTarget, true);
      });
    });
    setTour(false);
  });
})();
